import axios from "axios";
import qs from "qs";
import { createApp } from 'vue';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const isDist5000 = window.location.pathname.startsWith('/dist5000');
let common = {
    urlBase: isDist5000 ? 'http://localhost:5000/' : '/api/',

    //urlBase:"https://www.codessp.cn/api/",
    bus: createApp(),
    get: function (url, data) {
        url = this.urlBase + url;
        if (data == undefined) {
            data = {};
        }
        const cacheKey = `${url}|${JSON.stringify(data)}`; // 唯一化缓存 Key
        //const cacheKey = url + (data ? JSON.stringify(data) : ""); 
        try {
            let cacheKeys = ['chapterContent']
            let urlPath = url; // 提取纯路径（避免 query 干扰）
            if (urlPath.indexOf('?') != -1) {
                urlPath = url.substr(0, url.indexOf('?'));
            }
            console.log(urlPath)
            let isCache = cacheKeys.some(key => urlPath.includes(key));
            if (isCache) {
                // 1. 检查 Session 是否有缓存
                const cachedData = common.getFromSession(cacheKey);
                console.log(cacheKey + "------------");
                console.log(cachedData);
                // 假设你有 getFromSession 方法
                if (cachedData) {
                    console.log("[Cache Hit] Return data from session:", cacheKey);
                    // 返回一个 Promise 直接 resolve 缓存数据，保持调用方 then() 兼容
                    return Promise.resolve({ data: { data: cachedData }, status: "200" });
                }
            }
            // 2. 如果没有缓存，发起请求

            axios.defaults.withCredentials = false;
            return axios({
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                method: "get",
                url: url,
                params: data,
            }).then((res) => {
                // 3. 请求成功后，存储到 Session
                res.data.code = "200";
                console.log(cacheKey + "save to session:--------------------")
                console.log(res.data);
                if (isCache) {
                    common.setToSession(cacheKey, res.data.data);
                }

                return res; // 保持返回结构一致
            });
        } catch (e) {
            console.log(e);
            throw e;
        }
    },
    post: function (url, data) {
        url = this.urlBase + url;
        let t;
        axios.defaults.withCredentials = false;
        try {
            t = axios({
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                method: "post",
                url: url,
                data: qs.stringify(data),
            })
        } catch (e) {
            console.log(e);
            throw e;
        }
        return t;

    },

    postWithConfig: function (url, formData, config) {
        return axios
            .post(this.urlBase + url, formData, config)
    },

    //如果all为空，那么只取一级目录，如果all为sub，则取所有目录，并且折叠二三级目录；如果all为nowrap则不折叠二三级目录
    getChapters2(courseId, chapterId, setData, all) {
        if (all == undefined)
            all = "";
        let t = this.getFromSession("chapters" + courseId + all);
        if (!t) {
            this.post("chapters", { courseId: courseId, chapterId: chapterId, all: all }).then((response) => {
                //console.log(response.data.data);
                if (response.status == "200") {
                    // return response.data.data;
                    setData(response.data.data);
                    this.setToSession("chapters" + courseId + all, response.data.data);
                }
                //return null;
            });
        } else {
            setData(t);
        }

    },

    //如果all为空，那么只取一级目录，如果all为sub，则取所有目录，并且折叠二三级目录；如果all为nowrap则不折叠二三级目录
    getChapters(courseId, setData, all) {
        console.log("common.getChapters");
        console.log(courseId);
        this.getChapters2(courseId, "", setData, all)
    },


    //如果all为空，那么只取一级目录，如果all为sub，则取所有目录，并且折叠二三级目录；如果all为nowrap则不折叠二三级目录
    getChaptersById(chapterId, setData, all) {
        if (all == undefined)
            all = "";
        this.post("chaptersById", { chapterId: chapterId, all: all }).then((response) => {
            //console.log(response.data.data);
            if (response.status == "200") {
                // return response.data.data;
                setData(response.data.data)
            }
            //return null;
        });
    },

    /**
     * 从sessionStorage中删除包含指定关键字的第一个匹配项
     * @param {string} keyword - 要搜索的关键字
     * @param {boolean} [exactMatch=false] - 是否精确匹配(默认模糊匹配)
     * @returns {boolean} 是否找到并删除了匹配项
     */
    removeSessionItem(keyword, exactMatch = false) {
        const key = Object.keys(sessionStorage).find(k => {
            const keyMatch = exactMatch ? k === keyword : k.includes(keyword);
            return keyMatch;
        });

        if (key) {
            sessionStorage.removeItem(key);
            return true;
        }
        return false;
    },

    clearChapterSession: function (courseId, code) {
        let currentURL = "/chapterContent?courseId=" + courseId + "&cd=" + code;
        common.removeSessionItem(currentURL);
    },

    setToSession: function (key, value) {
        try {
            sessionStorage.setItem(key, encodeURIComponent(JSON.stringify(value)));
        } catch (e) {
            console.log(e);
            console.log("clear sessionStorage");
            sessionStorage.clear();
        }

    },


    setUser: function (user) {
        if (user) {
            //sessionStorage.setItem("user", JSON.stringify(user));
            this.setToSession("user", user)
        }
    },

    // setCourses: function (courses) {
    //     if (courses) {
    //         //sessionStorage.setItem("courses", JSON.stringify(courses));
    //         this.setToSession("courses", courses)
    //     }
    // },


    getFromSession: function (key) {
        let t = sessionStorage.getItem(key);
        if (t) {
            t = decodeURIComponent(t);
            return JSON.parse(t);
        }
        return null;
    },


    // getCourses: function () {
    //     return this.getFromSession("courses");
    // },

    getUser: function () {
        let isLogin = sessionStorage.getItem("isLogin");
        //console.log(this.user);
        if (isLogin) {
            let t = sessionStorage.getItem("user");
            console.log(t);

            //console.log(this.user.username + "," + this.user.role)
            if (t)
                return JSON.parse(t);
        }
        else {
            let t = this.getCookie("user");
            //console.log(t);
            if (t) {
               return JSON.parse(t);
            }
            return null;
        }
    },

    updateCourse: function (courseId, username) {
        this.post("updateCourse", { courseId: courseId, username: username }).then((response) => {
            if (response.data.code == 200) {
                this.setCourseToSession(courseId);
            }
        });
    },

    setCourseToSession: function (courseId) {
        sessionStorage.setItem("courseId", courseId);
    },

    getCourseIdFromSession: function () {
        let t = sessionStorage.getItem("courseId");
        //console.log(t)
        if (t)
            return t;
        else
            return "1";
    },

    getCourseId: function (username, setData) {
        this.get("courseId", { username: username }).then((response) => {
            //console.log(response.data.data);
            if (response.status == "200") {
                // return response.data.data;
                setData(response.data.data.courseId);
            }

        });

    },

    chapterNumber: function (code) {
        if (!code)
            return "";
        let firstLevelCode = code.substring(0, 2);
        let secondLevelCode = code.substring(2, 4);
        let thirdLevelCode = code.substring(4, 6);

        let m1 = parseInt(firstLevelCode);
        let m2 = parseInt(secondLevelCode);
        let m3 = parseInt(thirdLevelCode);

        let C = ['0', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十', '二一', '二二', '二三', '二四', '二五', '二六', '二七', '二八', '二九', '二十']
        let levelOne = '';
        if (m1 < 20) {
            levelOne = C[m1];
        } else {
            levelOne = m1;
        }
        if (m2 == 0 && m3 == 0)
            return "第" + levelOne + "章 ";
        if (m3 == 0) {
            return m1 + "." + m2 + "  ";
        }
        return m1 + "." + m2 + "." + m3 + "  ";
    },

    getChapterStudies: function (username, courseId, chapterId, setData) {
        this.post("chapterStudy",
            {
                username: username,
                courseId: courseId,
                chapterId: chapterId
            }).then((response) => {
                //console.log(response.data);
                if (response.status == "200") {
                    // return response.data.data;
                    setData(response.data);
                }
                //return null;
            });
    },

    blankAnswer: function (username, id, value, inputId, setData) {
        if (username == "null" || username == "") {
            if (confirm("未登录无法练习，需要登录吗？")) {
                window.location = "login.jsp";
            }
            return;
        }

        value = value.trim();
        if (value == "") {
            return;
        }

        this
            .post("chapterQuizStudySaving", {
                username: username,
                quizId: id,
                inputId: inputId,
                answer: value,
            })
            .then((response) => {
                let data = response.data.data;
                if (data) {
                    data = JSON.parse(data);
                    //this.comment = data.comment;
                    //this.stat = data.stat;
                    setData(data);
                    //console.log(this);

                    // $("#" + id).html(format($("#" + id).text()));
                    //$(":button").removeAttr("disabled");
                    // $(":input").removeAttr("disabled");
                    //$("#comment" + id).empty(); // 清掉批注，忘掉错对

                    // let respondText = "";
                    // if (commemt) respondText = codeFormator.reverseXMLFormat(commemt);

                    //   $("#comment" + id).html(data.comment);
                    //   console.log(id + "," + $("#comment" + id).html());

                    //   if (data.comment != "") {
                    //     $("#comment" + id).removeClass("correct");
                    //   } else {
                    //     $("#comment" + id).addClass("correct");
                    //   }
                }
            }).catch(err => {
                console.log("error");
                console.log(err);
            });
    },

    getFile: function (event, files, filesShow) {
        let file = event.target.files;
        for (let i = 0; i < file.length; i++) {
            //    上传类型判断
            let imgName = file[i].name;
            let idx = imgName.lastIndexOf(".");
            if (idx != -1) {
                let ext = imgName.substr(idx + 1).toUpperCase();
                ext = ext.toLowerCase();
                files.push(file[i]);
                // if (ext != "pdf" && ext != "doc" && ext != "docx") {
                // } else {

                // }
            } else {
                console.log(imgName);
            }

            if (filesShow) {
                let reader = new FileReader()
                reader.readAsDataURL(file[i])
                reader.onload = function () {
                    filesShow.push(reader.result);
                }
            }
        }

        return Promise.resolve(file);
    },

    getClasses(valid, setClasses) {
        //valid是all就查找所有班级，true查找可用班级,false查找所有不可用班级
        this.get("class", { valid: valid }).then((response) => {
            //console.log(JSON.parse(response.data.data.classes));
            setClasses(response.data.data.classes);
        })
    },

    correct(chapterId, classId) {
        this.post("batchCorrect", { chapterId: chapterId, classId: classId }).then((response => {
            console.log(response.data.info);
        }));
    },

    getRoomNames(appName, setRoomNames) {
        this.get("roomNames", { appName: appName }).then((response) => {
            console.log(response.data.data);
            setRoomNames(response.data.data);
        })
    },

    resetScore(courseId, classId,all) {
        this.post("recomputeScore", { courseId: courseId, classId: classId ,all:all});
    },

    resetUserScore(courseId, username) {
        this.post("recomputeUserScore", { courseId: courseId, username: username });

    },
    correction(code, courseId, username, setData) {
        this.post("ChapterQuizBatchCorrecting", {
            courseId: courseId,
            code: code,
            username: username
        }).then((response) => {
            if (response) {
                //$("#message").html(data.message);
                setData(response.data.info);
            }
        });
    },
    getChapterStudyScore(code, courseId, username, setData) {
        this.get("getChapterStudyScore", {
            courseId: courseId,
            code: code,
            username: username
        }).then((response) => {
            if (response) {
                //$("#message").html(data.message);
                setData(response.data.info);
            }
        });
    },
    //获取cookie、
    getCookie(c_name) {
        try {
            const value = document.cookie
                .split('; ')
                .find(row => row.startsWith(`${c_name}=`))
                ?.split('=')[1];

            return value ? decodeURIComponent(value) : null;
        } catch (e) {
            console.error('Error reading cookie:', e);
            return null;
        }
    },

    //设置cookie,增加到vue实例方便全局调用
    setCookie(c_name, value, expiredays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + expiredays);

        // 只使用 encodeURIComponent，不使用 escape
        let cookieValue = encodeURIComponent(value);

        // 设置 path=/ 让 cookie 在整个网站可用
        let cookie = `${c_name}=${cookieValue}; path=/`;

        if (expiredays) {
            cookie += `; expires=${exdate.toUTCString()}`;
        }

        // 如果需要安全 cookie (HTTPS)，可以添加 Secure
        // if (location.protocol === 'https:') {
        //     cookie += '; Secure';
        // }

        document.cookie = cookie;
    },
    //删除cookie
    delCookie(name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.getCookie(name);
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    },

    setLoginStatus(user, courseId) {
        sessionStorage.setItem("isLogin", "true");
        //console.log(res.data.data);
        //sessionStorage.setItem("courseId", res.data.data.course);
        sessionStorage.setItem("user", JSON.stringify(user));
        sessionStorage.setItem("courseId", courseId);

        //common.setCookie("user",JSON.stringify(user),60 * 60 * 24 * 30);

        //console.log(JSON.stringify(res.data.data.course))
        //this.$emit("login", "true");
        //this.lastUrl = sessionStorage.getItem("lastUrl");


    },

    exportToExcel: function (obj, json = {}) {
        // 支持 jQuery 对象或原生 DOM 元素
        const table = obj && obj.jquery ? obj[0] : obj;
        if (!table || table.tagName !== 'TABLE') {
            console.error('exportToExcel: 参数必须是 TABLE 元素');
            return;
        }
        const sheetName = json.sheetName || 'Sheet1';
        const filename = (json.filename || 'export') + '.xlsx';
        try {
            const wb = XLSX.utils.table_to_book(table, { sheet: sheetName });
            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            saveAs(new Blob([wbout], { type: 'application/octet-stream' }), filename);
        } catch (e) {
            console.error('exportToExcel 导出失败:', e);
        }
    },

    getTime(localTime) {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        if (month < 10) {
            month = "0" + month;
        }

        let day = date.getDate();
        if (day < 10) {
            day = "0" + day;
        }
        let splitor = " ";
        if (localTime) {
            splitor = "T";
        }
        let hour = date.getHours();
        let minute = date.getMinutes();
        let second = date.getSeconds();
        let time = year
            + '-' + month + '-' + day + splitor + hour + ':' + minute + ':' + second;
        return time;
    },

    getChapterTextCache: function (key) {
        let json = sessionStorage.getItem(key);
        if (json) {
            try {
                return JSON.parse(json);
            } catch (e) {
                return null;
            }
        }
        return null;
    },

    setChapterTextCache: function (key, data) {
        if (key && data) {
            sessionStorage.setItem(key, JSON.stringify(data));
        }
    },

    splitCodeResult(rst) {
        //console.log("================"+rst+"================")
        if (!rst) {
            return "";
        }
        // handle legacy @ separator format
        rst = rst.replace(/\r\n/g, "\n");
        let t = rst.split("@");
        let r = "";
        t.forEach(a => {
            r = r + a + "<br/>";
        });
        // convert newlines to <br/>
        r = r.replace(/\n/g, "<br/>");
        // simple markdown formatting for AI analysis
        r = r.replace(/###\s+(.+?)(?:<br\/>)/g, "<strong>$1</strong><br/>");
        r = r.replace(/##\s+(.+?)(?:<br\/>)/g, "<strong>$1</strong><br/>");
        r = r.replace(/#\s+(.+?)(?:<br\/>)/g, "<strong>$1</strong><br/>");
        r = r.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
        r = r.replace(/\*([^*]+?)\*/g, "<em>$1</em>");
        r = r.replace(/`([^`]+)`/g, "<code>$1</code>");
        r = r.replace(/- (.+?)(?:<br\/>)/g, "&bull; $1<br/>");
        r = r.replace(/```[\s\S]*?```/g, function(m) {
            return m.replace(/<br\/>/g, "\n").replace(/```\w*\n?/, "<pre><code>").replace(/\n?```/, "</code></pre>");
        });
        return r;
    },

    // /**
    //  * 执行代码并把结果返回到sel中console变量
    //  * @param {*} codeDivId 包含代码的元素id 
    //  * @param {*} sel 页面对象
    //  * @returns 
    //  */
    // executeCode(codeDivId,sel){
    //     let plainCode = $("#"+codeDivId).text();
    //     console.log(plainCode)
    //     let codeLang = "python";
    //     if (sel.courseId == 1) {
    //       codeLang = "java";
    //     }

    //     let code = $("#"+codeDivId).html();
    //     plainCode = $("#"+codeDivId).text()

    //     if (codeLang == "python") {
    //       //python处理转行,先测试有内容
    //       if (plainCode) {
    //         code = code.replace(/<br>/g, "\n");
    //         code = code.replaceAll("</div>", "\n</div>");
    //         if (code.indexOf("<code>") >= 0 || code.indexOf("<pre>") >= 0 || code.indexOf("codeNewLine") >= 0)
    //           code = $(code).text();
    //       } else {
    //         return;
    //       }

    //     } else {
    //       //如果不是python代码
    //       code = plainCode;
    //     }

    //     if (plainCode.match(/[\s]*input[\s]*/g)) {
    //       sel.console = "不支持输入语句";
    //       return;
    //     }

    //     common.post("exec", { code: code, codeLang: codeLang }).then(((res) => {
    //       console.log(res)
    //       if (res.data.data) {
    //         sel.console = res.data.data;
    //       }
    //     }))
    //   },

}
export default common;